import React from "react";
import Pagination from "react-js-pagination";
import { ButtonStateStyle } from "../../../../common/function/project";

const InviteActions = ({
  mberTotal,
  chkMberList,
  handleModalOpen,
  currentPage,
  pageSize,
  onPageChange,
}) => {
  if (mberTotal === 0) return null;

  return (
    <div className="inviteArea">
      <button
        onClick={() => handleModalOpen(chkMberList)}
        style={ButtonStateStyle(chkMberList.length > 0)}
        disabled={chkMberList.length === 0}>
        초대
      </button>
      <Pagination
        activePage={currentPage}
        itemsCountPerPage={pageSize}
        totalItemsCount={mberTotal}
        pageRangeDisplayed={5}
        prevPageText={"‹"}
        nextPageText={"›"}
        onChange={onPageChange}
      />
    </div>
  );
};

export default InviteActions;
